import api from './api'

const serviceService = {
  // Get all services
  getAllServices: async (params = {}) => {
    const response = await api.get('/services', { params })
    return response.data
  },

  // Get service by ID
  getServiceById: async (id) => {
    const response = await api.get(`/services/${id}`)
    return response.data
  },

  // Create service (admin)
  createService: async (serviceData) => {
    const response = await api.post('/services', serviceData)
    return response.data
  },

  // Update service (admin)
  updateService: async (id, serviceData) => {
    const response = await api.put(`/services/${id}`, serviceData)
    return response.data
  },

  // Delete service (admin)
  deleteService: async (id) => {
    const response = await api.delete(`/services/${id}`)
    return response.data
  },

  // Get availability for a service (public)
  getAvailability: async (id, startDate, endDate) => {
    const response = await api.get(`/services/${id}/availability`, {
      params: { start_date: startDate, end_date: endDate },
    })
    return response.data
  },
}

export default serviceService
